import { Modal } from "components/Modal";
import { PropertyService } from "@adfenix/types";
import { InviteSellerForm } from "./InviteSellerForm";

export const InviteSellerModalWithoutCDP = ({
  inviteSellerModal,
  setInviteSellerModal,
  property,
  hqId
}: {
  inviteSellerModal: boolean;
  setInviteSellerModal: (show: boolean) => void;
  property: PropertyService.PropertyWithCampaignsSearchModel;
  hqId?: string;
}) => {
  return (
    <Modal show={inviteSellerModal} onClose={() => setInviteSellerModal(false)}>
      <Modal.Card>
        <InviteSellerForm
          location={property.location.address}
          propertyId={property.id}
          hqId={hqId!}
          setInviteSellerModal={setInviteSellerModal}
        />
      </Modal.Card>
    </Modal>
  );
};
